<template>
  <div class="avecor-table fill-height" >
    <v-tabs
      fixed-tabs
      dark
      height="30"
      dense
      v-model="selectedProductsTab"
      class="promotion-tabs"
      background-color="#136DF5"
      style="position:fixed;top:35px;z-index:20;border-bottom:1px solid orange;" 
    >
      <v-tabs-slider color="#FFF" ></v-tabs-slider>
      <v-tab href="#products">Tuotteet</v-tab>
      <v-tab href="#samplePackages">Sovituspaketit</v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedProductsTab" class="fill-height">
      <v-tab-item value="products" class="fill-height no-scrollbars">
        <v-toolbar dense style="border-top:1px solid #ccc;position:fixed;top:61px;width:100%;background:#FFF !important;z-index:20"  flat>
          <v-toolbar-title >Tuotteet</v-toolbar-title>
          <v-col sm="1" pl-4 class="text-center">
            <div style="font-size:14px">{{amountOfActiveProducts}}</div>
            <div style="font-size:10px">Aktiivista tuotetta</div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col xs2>
            <!-- v-on:keyup.enter="productsSearch = productsSearchTerm" -->
            <v-text-field
              :value="productsSearch"
              @change="(event) => productsSearch = event"
              class="table-search avecor-select"
              label="Etsi tuotteita tästä"
              single-line
              hide-details
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <!--<AddProductVariation :addProductVariation="addProductVariation" :productId="selectedProductId" @close="addProductVariationDialog=false" :visible="addProductVariationDialog" ></AddProductVariation>-->
          <v-btn-toggle style="margin-right:20px;" v-model="whichProductsToShow" tile>
            <v-btn value="active" height="30" class="avecor-button-global">
              Aktiviiset
            </v-btn>
            <v-btn  class="avecor-button-global" height="30" value="archived">
              Arkistoidut
            </v-btn>
          </v-btn-toggle>
          
          
          
          
          <v-btn color="#000000" @click="addProduct"  dark class="avecor-button-global add-button mr-3">Lisää tuote</v-btn>
          <v-menu
            :offset-y="true"
            :nudge-bottom="0"
            :nudge-right="25"
            bottom
            :close-on-click="true"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                v-bind="attrs"
                v-on="on"
                class="avecor-button-global add-button "
              >
                Muut Toiminnot
              </v-btn>
            </template>

            <v-list>
              <v-list-item><v-list-item-title @click="exportColors()" style="cursor:pointer;">Export värit</v-list-item-title></v-list-item>
              <v-list-item><v-list-item-title @click="exportProducts('active')" style="cursor:pointer;">Export aktiiviset tuotteet</v-list-item-title></v-list-item>
              <v-list-item><v-list-item-title @click="exportProducts('archived')" style="cursor:pointer;">Export arkistoidut tuotteet</v-list-item-title></v-list-item>
              <v-list-item><v-list-item-title @click="exportArchivableProducts('export')" style="cursor:pointer;">Export arkistoitavat tuotteet</v-list-item-title></v-list-item>
              <v-list-item v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'"><v-list-item-title @click="exportArchivableProducts('archive')" style="cursor:pointer;">Arkistoi kriteeristön täyttävät tuotteet</v-list-item-title></v-list-item>
              <v-list-item v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'"><v-list-item-title @click="deleteEmptyPvs()" style="cursor:pointer;">Poista tyhjät tuotevariaatiot</v-list-item-title></v-list-item>
              <v-list-item v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'"><v-list-item-title @click="setPricingTableProducts()" style="cursor:pointer;">Merkkaa hinnaston tuotteet</v-list-item-title></v-list-item>
              <v-list-item v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'"><v-list-item-title @click="updateColorCodes()" style="cursor:pointer;">Korjaa värikoodi</v-list-item-title></v-list-item>
              <v-list-item v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'"><v-list-item-title @click="productsCreatedAfter()" style="cursor:pointer;">Luotu pvm jälkeen</v-list-item-title></v-list-item>
              <v-list-item v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'"><v-list-item-title @click="productsUpdatedAfter()" style="cursor:pointer;">Päivitetty pvm jälkeen</v-list-item-title></v-list-item>
              
              <v-list-item><v-list-item-title @click="productBulkEditVisible = true" style="cursor:pointer;">Merkkaamon muutos</v-list-item-title></v-list-item>
              <!-- <v-list-item><v-list-item-title @click="updateColorCodes()" style="cursor:pointer;">Korjaa värikoodi</v-list-item-title></v-list-item> -->
              <!-- <v-btn color="#000000" @click="exportColors()"  dark class="avecor-button-global add-button mb-2">Lataa värit</v-btn> -->
              <!-- <v-btn color="#000000" @click="transferProductCodes"  dark class="avecor-button-global add-button mb-2">Siirrä tuotekoodit</v-btn> -->
              <!-- <v-btn color="#000000" @click="addProductCodes"  dark class="avecor-button-global add-button mb-2">Lisää tuotekoodit</v-btn> -->
              <!-- <v-btn color="#000000" @click="updateSizes"  dark class="avecor-button-global add-button mb-2">Muokkaa koot</v-btn> -->
            </v-list>
          </v-menu>

          
          <!-- <AddProduct @close="addProductDialog=false" :visible="addProductDialog" ></AddProduct> -->
        </v-toolbar>
        <ProductExpand v-if="selectedProductId ? true: false" 
          :productId="selectedProductId" 
          :productVariationsForSelectedProduct="productsData[selectedProductId] !== undefined && productsData[selectedProductId].productVariations !== undefined ? productsData[selectedProductId].productVariations : {}" 
          :orderedProductsForSelectedProduct="productsData[selectedProductId] !== undefined && productsData[selectedProductId].orderedProducts !== undefined ? productsData[selectedProductId].orderedProducts : {}" 
          location="products"
          tab="productVariations"
        />
        <v-container class="products-table-headers-sticky" fluid >
          <v-row xs12 no-gutters>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="1" class="orders-custom-header pl-2">Toiminnot</v-col>
                <v-col cols="1" class="orders-custom-header text-center">Lisätty pvm</v-col>
                <v-col cols="2" class="orders-custom-header pl-3 pr-2 blue--text" style="text-decoration:underline;cursor:pointer;" @click="sortColumn = 'avecorSku'; sortAsc = !sortAsc">Avecor tuotekoodi</v-col>
                <v-col cols="2" class="orders-custom-header pl-0 pr-2 blue--text" style="text-decoration:underline;cursor:pointer;" @click="sortColumn = 'wholesaleSku'; sortAsc = !sortAsc">Tukkurin tuotekoodi</v-col>
                <v-col cols="2" class="orders-custom-header pl-0 pr-2 blue--text" style="text-decoration:underline;cursor:pointer;" @click="sortColumn = 'wholesaleSkus'; sortAsc = !sortAsc">Tukkurin variaatiokoodit</v-col>
                <!-- <v-col cols="1" class="orders-custom-header">Avecor id</v-col> -->
                <v-col cols="3" class="orders-custom-header pl-0 blue--text" style="text-decoration:underline;cursor:pointer;" @click="sortColumn = 'name'; sortAsc = !sortAsc">Tuotenimi</v-col>
                <v-col cols="1" class="orders-custom-header pl-2">ALV-kanta</v-col>
                
                
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="2" v-if="allAccess" class="orders-custom-header">Tukkuri</v-col>
                <v-col cols="1" class="orders-custom-header">Toimitusaika</v-col>
                <v-col cols="1" class="orders-custom-header">Merk. tuote?</v-col>
                <v-col cols="1" class="orders-custom-header">2-puoli merk?</v-col>
                <!-- <v-col cols="2" class="orders-custom-header">Merkkauspaikka</v-col> -->
                <v-col cols="2" v-if="allAccess" class="orders-custom-header">Merkkaamo</v-col>
                <v-col cols="1" class="orders-custom-header">Merkkaustavat</v-col>
                <!-- <v-col cols="1" class="orders-custom-header">Tuotetägit</v-col> -->
                    
                <v-col cols="5" v-if="!allAccess" class="orders-custom-header">-</v-col>

                <v-col cols="4" v-if="allAccess" class="orders-custom-header">Toimiston kommentti</v-col>
                <v-col cols="2" v-else class="orders-custom-header">-</v-col>
              </v-row>
            </v-col>
            
          </v-row>
        </v-container>
        <v-container fluid ma-0 px-0 style="height:100%;overflow-y:scroll;position:absolute; top:105px; padding-bottom:350px; width:100%;padding-top:25px;" >
          <v-lazy
            style="width:100%; padding:0px; margin:0px;min-height:30px"
            :options="{
              threshold: .1
            }"
            v-for="(p) in getProducts"
            :key="'product-'+p.id"
          >
            <v-row class="" no-gutters  style="width:100%; border-bottom:1px solid #ccc;" :key="keysObj[p.id] ? 'p-row-'+p.id +'-'+ keysObj[p.id] : 'p-row-'+p.id">
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="1" class="pl-2">
                    <div class="justify-center text-xs-center minw-75" >
                      <v-icon 
                        :size="9"
                        @click="selectedProductId = p.id;"
                        style="padding-right:1px;"
                      >
                        far fa-eye
                      </v-icon>
                      <v-icon 
                        v-if="p.warehoused"
                        :size="9"
                        @click="toggleWarehouse(p)"
                        color="green"
                        style="padding-right:1px;"
                      >fas fa-warehouse
                      </v-icon>
                      <v-icon 
                        v-if="!p.warehoused"
                        :size="9"
                        @click="toggleWarehouse(p)"
                        color="red"
                        style="padding-right:1px;"
                      >fas fa-warehouse
                      </v-icon>
                      <v-icon v-if="allAccess && p.listed" color="green" :size="9" @click.stop="toggleListed(p)" style="padding-right:1px;">fas fa-money-check-alt</v-icon>
                      <v-icon v-if="allAccess && !p.listed"  :size="9" @click.stop="toggleListed(p)" style="padding-right:1px;">fas fa-money-check-alt</v-icon>

                      <v-icon v-if="allAccess && p.archived" color="green" :size="9" @click.stop="toggleArchive(p)" style="padding-right:1px;">fas fa-archive</v-icon>
                      <v-icon v-if="allAccess && !p.archived"  :size="9" @click.stop="toggleArchive(p)" style="padding-right:1px;">fas fa-archive</v-icon>
                      
                      <v-icon :size="9" v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" @click="deleteProduct(p.id)" style="padding-right:1px;">far fa-trash-alt</v-icon>
                      <v-icon :size="9" v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="ml-2" @click="copyToClipboard(p.id)" >far fa-id-badge</v-icon>
                      <v-icon v-if="p.selectedProductImageId !== ''" size=8 @click="selectFileForMediaViewer(p.selectedProductImageId)">far fa-image</v-icon>
                    </div>
                  </v-col>
                  <v-col cols="1" class="text-center">
                    <div class="products-custom-field" @click="copyToClipboard(p.created_at ? customFormatter(p.created_at): '')" style="color:rgba(0,0,0,.38);">{{p.created_at ? customFormatter(p.created_at): ''}}</div>
                  </v-col>
                  <v-col cols="2" class="pl-3">
                    <!-- <div class="products-custom-field" @click="copyToClipboard(p.avecorSku)" style="color:rgba(0,0,0,.38);">{{p.avecorSku}}</div> -->
                    <v-text-field
                      :value="p.avecorSku"
                      dense
                      @change="(newSku) => updateProduct(p.id, 'avecorSku', newSku)"
                      class="manage-text-field avecor-select pt-0 mt-0 "
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <!-- <div class="products-custom-field" @click="copyToClipboard(p.wholesaleSku)" style="color:rgba(0,0,0,.38);">{{p.wholesaleSku}}</div> -->
                    <v-text-field
                      :value="p.wholesaleSku"
                      dense
                      @change="(newSku) => updateProduct(p.id, 'wholesaleSku', newSku)"
                      class="manage-text-field avecor-select pt-0 mt-0 "
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <div class="products-custom-field" @click="copyToClipboard(p.productVariationWholesaleSkus)" style="color:rgba(0,0,0,.38);">{{p.productVariationWholesaleSkus}}</div>
                  </v-col>
                  <v-col cols="3" >
                    <div class="products-custom-field" @click="copyToClipboard(p.name)" :style="p.name.includes('UUSI TUOTE') ? 'color:#F36639;' :'color:rgba(0,0,0,.38);padding-bottom:2px;cursor:pointer;'">{{p.name}}</div>
                    <div v-if="allAccess && p.nameWholesale" @click="copyToClipboard(p.nameWholesale)" style="line-height:12px;margin-bottom:3px;cursor:pointer;"><span style="background:orange;padding:0 3px;font-size:10px;"><i>T: {{p.nameWholesale}}</i></span></div>
                    <!-- <div v-if="allAccess && p.nameEnglish" @click="copyToClipboard(p.nameEnglish)" style="line-height:12px;margin-bottom:3px;cursor:pointer;"><span style="background:orange;padding:0 3px;font-size:10px;"><i>EN: {{p.nameEnglish}}</i></span></div> -->
                  </v-col>
                  <!-- @change="v => $store.dispatch('changeSalespersonForCompany', {companyId:c.id,newSalesperson:v})" -->
                  <v-col cols="1" class="orders-custom-field pr-5 pt-1">
                    <v-autocomplete
                      :value="p.vatPercentage"
                      :items="Object.keys(settings.vatPercentages).map(voId => {return settings.vatPercentages[voId]})"
                      :disabled="!allAccess"
                      @change="(newVatPercentage) => updateProduct(p.id, 'vatPercentage', newVatPercentage)"
                      persistent-hint
                      item-text="text"
                      item-value="id"
                      hide-details
                      dense
                      class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    />
                  </v-col>
                </v-row> 
              </v-col> 
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="2">
                    <!-- SAMI H MYÖS -->
                    <div v-if="allAccess || user.uid === 'od6hpMLCPVSywiM17gt2MrIrq0i1'" class="products-custom-field" style="color:rgba(0,0,0,.38);">{{p.wholesaleCompany}}</div>
                  </v-col>
                  <v-col cols="1">
                    <div class="products-custom-field" @click="copyToClipboard(p.deliveryTime)" style="color:rgba(0,0,0,.38);">{{p.deliveryTime}}</div>
                  </v-col>
                  <v-col cols="1">
                    <div class="products-custom-field" style="color:rgba(0,0,0,.38);">{{p.isPrintProduct}}</div>
                  </v-col> 
                  <v-col cols="1">
                    <div class="products-custom-field" style="color:rgba(0,0,0,.38);">{{p.isDoubleSidePrintPossible}}</div>
                  </v-col>
                  <v-col cols="2" v-if="allAccess">
                    <div class="products-custom-field" style="color:rgba(0,0,0,.38);">{{p.printShops}}</div>
                  </v-col>
                  <v-col cols="1">
                    <div class="products-custom-field" style="color:rgba(0,0,0,.38);">{{p.printFormats}}</div>
                  </v-col>
                  <v-col cols="4" >
                    <div 
                      v-if="allAccess"
                      class="products-custom-field" @click="copyToClipboard(p.officeComments)" style="color:rgba(0,0,0,.38);">
                      <pre style="white-space: pre-wrap;">{{p.officeComments}}</pre>
                    </div>
                  </v-col>
                  
                  <!-- <v-col cols="2">
                    <div class="products-custom-field" style="color:rgba(0,0,0,.38);">{{p.productTags}}</div>
                  </v-col> -->
                </v-row>
              </v-col>
            </v-row>
          </v-lazy>
          <v-row no-gutters style="height:300px; margin-top:50px;margin-bottom:50px;">
            <v-col cols="12" class="text-center">
              <v-btn v-if="isThereMoreProductsToShow" color="orange" style="color:#fff" @click="productsToShow = productsToShow + productsToShowIncrement">Näytä lisää tuotteita</v-btn>
            </v-col>
          </v-row>
        </v-container>
        <MediaViewer :selectedFile="selectedFileForMediaViewer" />
      </v-tab-item>
      <v-tab-item value="samplePackages" class="fill-height" style="position:absolute; top:48px;width:100%;">
        <v-row no-gutters class="fill-height">
          <v-col cols="2" style="border-right:1px solid #eee" class="">
            <v-row no-gutters style="color:#888; background:#FFF; line-height:40px" class="pl-3 pr-5">
              Sovituspaketit
              <v-spacer></v-spacer>
              <button style="outline:none" @mouseup.stop="addList()">
                <v-icon :size=12 color='#888'>fas fa-plus</v-icon>
              </button>
            </v-row>
            <v-list dense class="pa-0 ma-0">
              <v-list-item-group   color="primary" >
                <v-list-item
                  v-for="(item) in Object.keys(getSamplePackages).reduce((result,key) => {result.push({text:samplePackages[key].name,value:samplePackages[key].id}); return result},[])"
                  :key="item.value"
                  :value="item.value"
                  @click="v => setPackage(item.value)"
                >
                  <v-list-item-content>
                    <v-row no-gutters>
                      <v-col cols="10" >
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                      </v-col>
                      <v-spacer />
                      <v-col cols="2" class="text-right pr-5">
                        <v-icon class="button-pointer" @mouseup.stop="deleteList(item.value)" v-if="selectedSamplePackage === item.value" :size=12 color='#000'>fas fa-trash</v-icon>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="6" v-if="selectedSamplePackage !== ''" class="pl-5 pt-5 pr-5" style="border-right:1px solid #eee">
            <v-row no-gutters class="mt-2">
              <v-col cols="5" class="pr-5">
                <v-text-field
                  label="Sovituspaketin nimi"
                  :value="samplePackages[selectedSamplePackage] !== undefined ? samplePackages[selectedSamplePackage].name : ''"
                  dense
                  @change="(name) => updateSamplePackageName(name)"
                  class="manage-text-field"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row no-gutters class="mt-6">
              <div>Lisää tuotevariaatio Sovituspakettiin</div>
            </v-row> -->
            <v-row no-gutters>
              <v-col cols="5" class="pr-5">
                <v-autocomplete
                  v-model="selectedProductForList"
                  :items="getCatalogProducts"
                  label="Valitse tuote"
                  placeholder=" "
                  item-text="text"
                  item-value="value"
                  :error-messages="addExistingProductErrors.product"
                  @blur="(event) => {event === '' ? addExistingProductErrors.product = 'Täytä kenttä' : addExistingProductErrors.product = '';}"
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :input-value="data.selected"
                      small
                      close
                      class="chip--select-multi"
                      @click:close="removeProductSelectionForList()"
                    >
                      {{ data.item.text.substr(0,20) }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" class="pr-5">
                <v-list dense class="pa-0 ma-0">
                  <v-list-item-group color="primary" v-if="selectedProductForList !== ''">
                    <v-list-item
                      v-for="(item) in getProductVariationsForProduct"
                      :key="item.value"
                      :value="item.value"
                    >
                      <v-list-item-content>
                        <v-row no-gutters>
                          <v-col cols="6" >
                            <v-list-item-title v-text="item.text"></v-list-item-title>
                          </v-col>
                          <v-spacer />
                          <v-col cols="2" class="text-right pr-5">
                            <v-btn @click="addProductVariationToList(item.value)"  class="add-button avecor-button-global mr-3" >Lisää pakettiin</v-btn>
                            <!-- <v-icon @mouseup.stop="deleteList(item.value)" v-if="selectedSamplePackage === item.value" :size=12 color='#000'>fas fa-trash</v-icon> -->
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" v-if="selectedSamplePackage !== ''" class="pt-5">
            <v-row no-gutters style="color:#888; background:#FFF; line-height:40px" class="pl-3 pr-5">
              Tuotevariaatiot listalla
              <v-spacer></v-spacer>
              <!-- <v-icon :size=12 color='#888'>fas fa-plus</v-icon> -->
            </v-row>
            <v-list dense class=" ma-0">
              <v-list >
                <v-list-item
                  v-for="(item,index) in samplePackages[selectedSamplePackage].productVariations"
                  :key="'list-product-variations-productvariation-'+index"
                  :value="item.value"
                >
                  
                  <v-list-item-content >
                    <!-- <div>{{samplePackages[selectedSamplePackage].contacts}}</div> -->
                    <v-row no-gutters v-if="productVariations[item.productVariationId] !== undefined">
                      <v-col cols="1">
                        <v-icon class="button-pointer" @mouseup.stop="removeProductVariationFromList(item.productVariationId)" :size=14 color='#888'>fas fa-trash</v-icon>
                      </v-col>
                      <v-col cols="11">
                        <v-list-item-title v-text="productsData[productVariations[item.productVariationId].productId].name +'-'+ createVariationName(productVariations[item.productVariationId])"></v-list-item-title>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-list>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    <AddProduct />
    <BulkProductEdit />
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import firebase from 'firebase'
import shared from './../../shared'
import { ExportToCsv } from 'export-to-csv';

var db = null

import ProductExpand from './ProductExpand'
import AddProduct from './AddProduct'
import BulkProductEdit from './BulkProductEdit'

export default {
    components: {
      ProductExpand,
      AddProduct,
      BulkProductEdit
    },
    created () {
      this.createVariationName = shared.createVariationName
      this.createVariationAvecorSku = shared.createVariationAvecorSku
    },
    data: () => ({
      keysObj:{},
      noSliceForProducts:false,
      sortColumn:'name',
      sortAsc:true,
      selectedSamplePackage:'',
      selectedProductVariationForList:'',
      selectedProductForList:'',
      samplePackages:{},
      selectedProductsTab:'products',
      amountOfActiveProducts:0,
      productsToShow:250,
      productsToShowIncrement:500,
      isThereMoreProductsToShow:false,
      productsSearch: '',
      selectedFileForMediaViewer:"",
      productsData: {},
      whichProductsToShow: "active",
      selected: ["Avecor Oy"],
      addProductDialog: false,
      addProductVariationDialog: false,
      selectedOrderId: null,
      table: null,
      search: '',
      addExistingProductErrors:{
        productVariation:"",
        product:"",
      },
      newItem: {
        name: {
          fi: '((UUSI TUOTE))'
        },
        printFormats:[],
        deliveryTime:'',
        isPrintProduct: false,
        isDoubleSidePrintPossible: false,
        productTags: [],
        wholesaleCompany: ' ',
      },
      defaultItem: {
        name: {
          fi: ''
        },
        printFormats:[],
        deliveryTime:'',
        isPrintProduct: false,
        isDoubleSidePrintPossible: false,
        productTags: [],
        wholesaleCompany: ' ',
      },
    }),
    watch: {
      productVariations: {
        handler(val){
          //console.log("GENERATING PRODUCTS DATA")
          this.generateProductsData()
        },
        deep: true
      },
      products: {
        handler(val){
          //console.log("GENERATING PRODUCTS DATA")
          this.generateProductsData()
        },
        deep: true
      },
      loaded:{
        handler(val){
          this.generateProductsData()
        },
      }
    },
    computed: {
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      highestProductNumber(){
        var highestProductNumber = 0
        Object.keys(this.products).forEach(key => {
          var p = this.products[key]
          var avecorSku = p.avecorSku ? p.avecorSku.toString() : ''
          avecorSku = avecorSku.trim()
          if(avecorSku && !isNaN(Number(avecorSku))){
            var num = Number(p.avecorSku)
            if (num > highestProductNumber) highestProductNumber = num
          }
        })
        return highestProductNumber + 1
        
      },
      getProductVariationsForProduct(){
        var productsData = this.productsData
        var productVariations = this.productVariations
        var selectedProductForList = this.selectedProductForList
        var catalogProducts = []
        Object.keys(productVariations).forEach(key => {
          var pv = productVariations[key]
          if(productsData[pv.productId] !== undefined && pv.productId === selectedProductForList){
            catalogProducts.push({text: productsData[pv.productId].name + " - " + this.createVariationName(pv), value: pv.id})
          }
        })
        return catalogProducts
      },
      getSamplePackages(){
        return this.samplePackages
      },
      getCatalogProducts(){
        var productsData = this.productsData
        var catalogProducts = []
        Object.keys(productsData).map(function(key, index) {
          if(productsData[key] !== undefined) {
            var p = productsData[key]
            if (p.archived === undefined || p.archived == false){
              catalogProducts.push({text: p.name, value:key})
            }
          }
          return ""
        })
        return catalogProducts
      },
      getProducts(){
        var t = this
        var products = this.products
        var selectedProducts = []
        var newProducts = []
        var amountOfActiveProducts = 0
        
        const keys = Object.keys(this.productsData)
        if (keys.length == 0) return []
        for (const key of keys) {
          var p = this.productsData[key]
          if(!p.archived) amountOfActiveProducts++

          if (this.whichProductsToShow === "archived" && p.archived) {
            if (this.productsSearch !== ""){
              var productTextsToSearch = ""
              if(p.name) productTextsToSearch += p.name
              if(p.avecorSku) productTextsToSearch += p.avecorSku
              Object.keys(p.productVariations).forEach(pvId => {
                if(p.avecorSku && p.productVariations[pvId].colorCode) {
                  productTextsToSearch += p.avecorSku + '-' + p.productVariations[pvId].colorCode
                }
              })
              if(p.wholesaleSku) productTextsToSearch += p.wholesaleSku
              if(p.id) productTextsToSearch += p.id
              if(p.wholesaleCompany) productTextsToSearch += p.wholesaleCompany
              if(p.officeComments) productTextsToSearch += p.officeComments
              if(p.printShops) productTextsToSearch += p.printShops
              if(productTextsToSearch.toLowerCase().includes(this.productsSearch.toLowerCase())) selectedProducts.push(p)
            }
            else {
              if(this.productsData[key].name.includes("UUSI TUOTE")) newProducts.push(p); 
              else selectedProducts.push(p)
            }
          }
          else if (this.whichProductsToShow === "active" && !p.archived) {
            if (this.productsSearch !== ""){
              var productTextsToSearch = ""
              if(p.name) productTextsToSearch += p.name
              if(p.nameWholesale) productTextsToSearch += p.nameWholesale
              if(p.nameEnglish) productTextsToSearch += p.nameEnglish
              if(p.avecorSku) productTextsToSearch += p.avecorSku
              Object.keys(p.productVariations).forEach(pvId => {
                if(p.avecorSku && p.productVariations[pvId].colorCode) {
                  productTextsToSearch += p.avecorSku + '-' + p.productVariations[pvId].colorCode
                }
              })
              if(p.wholesaleSku) productTextsToSearch += p.wholesaleSku
              if(p.id) productTextsToSearch += p.id
              if(p.wholesaleCompany) productTextsToSearch += p.wholesaleCompany
              if(p.productVariationWholesaleSkus) productTextsToSearch += p.productVariationWholesaleSkus
              if(p.officeComments) productTextsToSearch += p.officeComments
              if(p.printShops) productTextsToSearch += p.printShops
              if(productTextsToSearch.toLowerCase().includes(this.productsSearch.toLowerCase())) selectedProducts.push(p)
            }
            else {
              if(this.productsData[key].name.includes("UUSI TUOTE")) newProducts.push(p); 
              else selectedProducts.push(p)
            }
          }
          
        }
        newProducts.map(product => selectedProducts.unshift(product))
        this.amountOfActiveProducts = amountOfActiveProducts

        var sortedProducts = selectedProducts.sort((a,b)=>{
          var nameA, nameB
          if(this.sortColumn ==='name'){ nameA=a.name.toLowerCase().trim(), nameB=b.name.toLowerCase().trim();}
          else if(this.sortColumn ==='wholesaleSkus'){ nameA=a.productVariationWholesaleSkus.toLowerCase().trim(), nameB=b.productVariationWholesaleSkus.toLowerCase().trim();}
          else if(this.sortColumn ==='avecorSku'){ 
            nameA=isNaN(Number(a.avecorSku)) ? 0 : Number(a.avecorSku), nameB= isNaN(Number(b.avecorSku)) ? 0 : Number(b.avecorSku)
          }
          else if(this.sortColumn ==='wholesaleSku'){nameA=a.wholesaleSku.toLowerCase().trim(), nameB=b.wholesaleSku.toLowerCase().trim();}
          if(this.sortColumn === 'avecorSku'){
            if(this.sortAsc) return nameA - nameB  
            else return nameB - nameA
          }
          else {
            if(this.sortAsc){
              
              if (nameA > nameB) {return 1;}
              if (nameB > nameA) {return -1;}
              return 0;
            }
            else{
              if (nameA < nameB) {return 1;}
              if (nameB < nameA) {return -1;}
              return 0;
            }
          }
        })
        if(this.noSliceForProducts){
          return sortedProducts
        }
        else {
          var sliceEnd = 0
          if(this.productsToShow > sortedProducts.length) {
            this.isThereMoreProductsToShow = false
            sliceEnd = sortedProducts.length
          }
          else {
            this.isThereMoreProductsToShow = true
            sliceEnd = this.productsToShow
          }
          return sortedProducts.slice(0,sliceEnd)
        }
      },
      
      ...mapFields({
        settings:"settings",
        products:'product.products',
        productVariations:'productVariation.productVariations',
        orderedProducts:'orderedProduct.orderedProducts',
        wholesaleCompanies:'wholesaleCompany.wholesaleCompanies',
        printShops:'printShop.printShops',
        ordersSearch:"settings.ordersSearch",
        //productsSearch:"settings.productsSearch",
        productsSearchTerm:"settings.productsSearchTerm",
        printFormatsObject:"settings.printFormatsObject",
        salesConsole:"views.salesConsole",
        companySelectedInModel:"settings.companySelectedInModel",
        productBulkEditVisible:"modals.product.bulkEdit.visible",
        selectedProductId:"views.products.selectedProduct.productId",
        user:"user",
        staff:"staff.staff",
        newProductVariation:"newRecords.newProductVariation",
        loaded:"settings.loaded",
        newProductModalVisible:"modals.product.new.visible",
      })
      
    },
    mounted() {
      const table = this.$refs.table
      this.productsSearch = this.productsSearchTerm
      this.generateProductsData()
      db = firebase.firestore();

      var t = this
      db.collection("samplePackages")
        .onSnapshot(function(querySnapshot) {
          t.samplePackages = {}
          querySnapshot.forEach(function(doc) {
              t.samplePackages[doc.id] = {...doc.data()}
          });
      })
    },
    methods: {
      productsCreatedAfter(){
        Object.keys(this.productsData).forEach(pId => {
            var date = this.productsData[pId].created_at
            var pDate = new Date(date.seconds*1000)
            var d12_1 = new Date(2024,0,12)
            if(pDate > d12_1) console.log(this.productsData[pId])

            //console.log(this.productsData[pId].created_at)
        });
      },
      productsUpdatedAfter(){
        Object.keys(this.productsData).forEach(pId => {
            if(this.productsData[pId].updated_at){
              var date = this.productsData[pId].updated_at
              var pDate = new Date(date.seconds*1000)
              var d12_1 = new Date(2024,0,12)
              if(pDate > d12_1) console.log(this.productsData[pId])
            }
            //console.log(this.productsData[pId].created_at)
        });
      },
      setPricingTableProducts(){
        var avecorSkus = [12568,12321,12558,12559,12384,12561,12596,12317,12547,12466,12556,12083,12534,12249,12543,12524,12522,12523,12334,12487,12464,12465,12490,12419,12266,12311,12312,12300,12437,12449,12447,12448,12165,12066,12067,10222,10024,10231,11062,10234,11181,11182,12234,10086,12125,10533,10136,10260,10122,10005,12289,12387,10201,10014,10553,10049,12378,10658,12374,10068,10000,12512,10310,10311,10313,11117,12124,12059,10180,10164,12397,12105,12355,12388,10095,10098,10320,10324,10192,10194,11103,10345,12566,12248,11179,11133,10034,10038,10042,10158,10196,12488,10413,10418,10071,11196,11197,10026,10139,10145,10147,10393,11681,10399,10402,10404,12157,12322,10092,10447,11342,11342,11342,11345,11345,11345,11344,11344,11344,10133,10215,12386,11743,12295,10545,11336,12106,11606,10557,11143,11138,10472,10472,10472,10218,10219,10676,10568,10592,10576,10578,12385,11423,11066,11098,10595,10597,10628,10626,12218,12156,10106,10600,12354,12047,11121,11155,10152,10505,11183,11349,12060,10508,10664,11985,11104,10492,12046,10502,10022,10693,10766,10767,11998,11106,10770,10771,10772,10773,10774,10775,10776,10065,10779,10794,10782,10785,11700,10958,10791,10791,10798,10798,10798,10798,10800,10801,10804,10805,10807,10919,10915,10813,10674,10858,10863,10868,10870,10876,10829,10837,10878,10850,10081,11314,10869,10907,10893,12514,12515,11068,11906,11825,11792,12507,11154,10924,10925,10934,10935,10941,10943,10918,10063,10089,10946,10947,10949,10950,10951,10953,10955,10956,10957,10954,10976,10977,10978,10820,10917,11024,11053,11757,11032,11039,11784,11042,11044,11047,11054,10993,11142,11058]
        //var maaritSkus = [11207,11208,11209,11210,11211,11212,11213,11214,11215,11216,11217,11218,11219,11220,11221,11222,11223,11224,11320,11226,11227,11272,11248,11249,11243,11228,11229,11315,11316,11321,11231,11232,11233,11234,11326,12135,10804,11173,11172,12158,12170,11230,12586,11235,11237,11238,11241,11242,11244,11245,11313,11322,12587,12588]
        var productIds = []
        var duplicates = []
        var avecorSkusObject = {}
        avecorSkus.forEach(sku => {
          avecorSkusObject[sku] = false
        })
        // FIND PRODUCT IDS
        Object.keys(this.products).forEach(pId => {
          var p = this.products[pId]
          if(p.avecorSku){
            var avecorSku = p.avecorSku
            //console.log(avecorSku)
            avecorSku = avecorSku.toString().trim()
            avecorSku = Number(avecorSku)
            if(avecorSkus.includes(avecorSku)) {
              if(avecorSkusObject[avecorSku]) duplicates.push(avecorSku)
              avecorSkusObject[avecorSku] = true
              productIds.push(p.id)
            }
            //else console.log(avecorSku)
          }
        })
        console.log("Avecor skus length: " + avecorSkus.length)
        console.log("Avecor skus object length: " + Object.keys(avecorSkusObject).length)
        console.log("Product ids length: " + productIds.length)
        //console.log(duplicates)
        

        /* Object.keys(avecorSkusObject).forEach(sku => {
          if(!avecorSkusObject[sku]) console.log(sku)
        }) */

        productIds.forEach(pId => {
          //console.log(pId)
          this.$store.dispatch('product/set', {
            id:pId, 
            listed:true
          })
        })

        // SET VALUE TO PRODUCTS

      },
      exportArchivableProducts(type){
        var products = {}
        Object.keys(this.products).forEach(pId => {
          var p = this.products[pId]
          if(p.archived) return
          if(p.listed) return
          if(p.autoArchiveDisabled) return
          products[pId] = {archive:true,lastDateOrdered:'', name:p.name.fi,code:p.avecorSku,wholesaleSku:p.wholesaleSku, pvs:{},stock:0}
        })
        Object.keys(this.productVariations).forEach(pvId => {
          var pv = this.productVariations[pvId]
          if(products[pv.productId]){
            if(pv.avecorStock && !isNaN(Number(pv.avecorStock)) && Number(pv.avecorStock) > 0) products[pv.productId].stock += Number(pv.avecorStock)
            var name = products[pv.productId].name + " - " +  this.createVariationName(this.productVariations[pv.id])
            products[pv.productId].pvs[pv.id] = {archive:true, lastDateOrdered:'',name, warehoused:pv.warehoused, avecorStock:pv.avecorStock ? pv.avecorStock : 0}

            if(pv.avecorStock && !isNaN(Number(pv.avecorStock)) && Number(pv.avecorStock) > 0) products[pv.productId].archive = false // IF THERE IS STOCK AVAILABLE DON'T ARCHIVE
            if(pv.batches !== undefined){
              Object.keys(pv.batches).forEach(batchId =>{
                var b = pv.batches[batchId]
                if (b.status !== 'batchShelfed') {
                  products[pv.productId].archive = false
                  products[pv.productId].pvs[pv.id].archive = false
                }
              })
            }
          } 
        })
        Object.keys(this.orderedProducts).forEach(opId => {
          var op = this.orderedProducts[opId]
          if(products[op.productId] && products[op.productId].pvs[op.productVariationId]){
            if(op.created_at.seconds){
              var created_date = new Date(op.created_at.seconds*1000);
              var product_created_date = this.products[op.productId] && this.products[op.productId].created_at ? new Date(this.products[op.productId].created_at.seconds*1000) : ''
              var one_year_from_now = new Date(new Date().setFullYear(new Date().getFullYear() - 1))
              var one_and_a_half_years_from_now = new Date(new Date().setFullYear(new Date().getFullYear() - 1))
              one_and_a_half_years_from_now.setMonth(one_and_a_half_years_from_now.getMonth() - 6);
              //console.log(past_date)
              if(created_date > one_and_a_half_years_from_now) {
                products[op.productId].archive = false
                products[op.productId].pvs[op.productVariationId].archive = false
                
                if(products[op.productId].pvs[op.productVariationId].lastDateOrdered && created_date > products[op.productId].pvs[op.productVariationId].lastDateOrdered) products[op.productId].pvs[op.productVariationId].lastDateOrdered = created_date
                else if(!products[op.productId].pvs[op.productVariationId].lastDateOrdered) products[op.productId].pvs[op.productVariationId].lastDateOrdered = created_date

                if(products[op.productId].lastDateOrdered && created_date > products[op.productId].lastDateOrdered) products[op.productId].lastDateOrdered = created_date
                else if(!products[op.productId].lastDateOrdered) products[op.productId].lastDateOrdered = created_date
              }
              else if (product_created_date > one_year_from_now){
                products[op.productId].archive = false
                products[op.productId].pvs[op.productVariationId].archive = false
              }
            }
          } 
        })

        // EXPORT
        if(type === 'export'){
          var data = []
          Object.keys(products).forEach(pId => {
            if(products[pId].archive) {
              var p = this.products[pId]
              var product = {
                Avecor_tuotekoodi:p.avecorSku ? p.avecorSku : '',
                Tukkurin_tuotekoodi:p.wholesaleSku ? p.wholesaleSku : '',
                Nimi: p.name.fi,
                Varastotuote:p.warehoused ? 'x' : '',
                Hinnastossa:p.listed ? 'x' : '',
                Saldo:products[pId].stock ? products[pId].stock : '',
                Tukkuri:this.wholesaleCompanies[p.wholesaleCompany] ? this.wholesaleCompanies[p.wholesaleCompany].name : '',
              }
              data.push(product)
            }
          })
          const options = { 
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            filename:'Avecor arkistoitavat tuotteet', 
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
          };
          const csvExporter = new ExportToCsv(options);
          csvExporter.generateCsv(data);
        }
// 
        else if(type === 'archive'){
          var pIdsToArchive = []
          var pvIdsToArchive = []
          Object.keys(products).forEach(pId => {
            if(products[pId].archive) {
              pIdsToArchive.push(pId)
              Object.keys(products[pId].pvs).forEach(pvId => {
                if(!this.productVariations[pvId].archived) pvIdsToArchive.push(pvId)
                
              })
            }
          })
          console.log(pIdsToArchive)
          console.log(pvIdsToArchive)

          /* for(var i = 0; i < 300; i++){
            var id = pvIdsToArchive[i] 
            //console.log(id)
            if(pvIdsToArchive[i]){
              this.$store.dispatch('productVariation/set', {
                id,
                archived:true
              })
            }
          } */
          /* for(var i = 0; i < 300; i++){
            //console.log(id)
            if(pIdsToArchive[i]){
              var id = pIdsToArchive[i]
              this.$store.dispatch('product/set', {
                id,
                archived:true
              })
            }
          } */
        }

      },
      deleteEmptyPvs(){
        var e = []
        Object.keys(this.productVariations).forEach(pvId => {
          if(this.productVariations[pvId].productId === undefined) e.push(pvId)
        })
        console.log(this.productVariations[e[1]])
        for(var i = 0; i < 300; i++){
          if(e[i]){
            this.$store.dispatch('productVariation/delete', e[i])  
          }
        }
        console.log(e)
      },
      exportProducts(typeOfProducts){
        var originalWhichProductsToShow = this.whichProductsToShow
        var originalProductsSearch = this.productsSearch
        if(typeOfProducts === 'archived'){
          this.whichProductsToShow = "archived"
          this.productsSearch = ""
        }
        else if(typeOfProducts === 'active'){
          this.whichProductsToShow = "active"
          this.productsSearch = ""
        }
        this.noSliceForProducts = true
        var data = []
        var product = ''
        var name = ''
        
        for (const p of this.getProducts) {
          for (const pvId of Object.keys(p.productVariations)) {
            var pv = p.productVariations[pvId]
            product = {
              Avecor_tuotekoodi:this.createVariationAvecorSku(pvId).toString(),//p.avecorSku,
              Tukkurin_tuotekoodi:p.wholesaleSku,
              Nimi: p.name + " - " +  this.createVariationName(this.productVariations[pvId]),
              Värikoodi:pv.colorCode ? pv.colorCode : '',
              Väri:this.settings.colors[pv.colorCode] ? this.settings.colors[pv.colorCode].fi : '',
              Koko:pv.size ? pv.size : '',
              Varastotuote:pv.warehoused ? 'x' : '',
              Tukkuri:p.wholesaleCompany,
              Toimitusaika:p.deliveryTime,
              Merkkaustuote:p.isPrintProduct,
              Kaks_puoli_merkkaus:p.isDoubleSidePrintPossible,
              Merkkaamo:p.printShops
            }
            data.push(product)
          }
        }

        const options = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          filename:'Avecor tuotteet', 
          //showTitle: true,
          //title:name +  'Kontaktitiedot',
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
        };
        
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(data);
        this.noSliceForProducts = false
        this.whichProductsToShow = originalWhichProductsToShow
        this.productsSearch = originalProductsSearch
      },
      exportColors(){
        var data = []
        var contact = ''
        var name = ''
        
        for (const colorId of Object.keys(this.settings.colors)) {
          var color = this.settings.colors[colorId]
          
          contact = {
            variluokkien_nimet: '"'+color.classNames+'"',
            variluokat:'"'+color.classes+'"',
            vari_suomeksi: color.fi,
            vari_englanniksi:color.en,
            varikoodi: color.id
          }
          data.push(contact)
        }

        const options = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          filename:'Avecor Värit', 
          //showTitle: true,
          //title:name +  'Kontaktitiedot',
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
        };
        
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(data);
      },
      setPackage(v){
        if (this.selectedSamplePackage === v) {
          console.log(v)
          this.selectedSamplePackage = ''
        }
        else{
          this.selectedSamplePackage = v
        }
      },
      addProductVariationToList(id){
        var errors = false
        
        if (errors) {alert('Tuotevariaatio valittava');return}
        const listRef = db.collection('samplePackages').doc(this.selectedSamplePackage).set({
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid,
          productVariations:firebase.firestore.FieldValue.arrayUnion({productVariationId:id}),
        }, { merge: true })
        this.selectedProductVariationForList = ''
      },
      addProductVariationToList2(){
        var errors = false
        if(this.selectedProductVariationForList === '') {this.addExistingProductErrors.productVariation = 'Täytä kenttä'; errors = true}
        if (errors) return
        const listRef = db.collection('samplePackages').doc(this.selectedSamplePackage).set({
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid,
          productVariations:firebase.firestore.FieldValue.arrayUnion({productVariationId:this.selectedProductVariationForList}),
        }, { merge: true })
        this.selectedProductVariationForList = ''
      },
      removeProductVariationFromList(productVariationId){
        console.log(productVariationId)
        const listRef = db.collection('samplePackages').doc(this.selectedSamplePackage).set({
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid,
          productVariations:firebase.firestore.FieldValue.arrayRemove({productVariationId}),
        }, { merge: true })
      },
      async addList(){
        const listRef = db.collection('samplePackages').doc()
        const listId = listRef.id
        await listRef.set({
          id:listId,
          created_at:firebase.firestore.FieldValue.serverTimestamp(),
          created_by:this.user.uid,
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid,
          name:'Uusi Sovituspaketti'
        })
      },
      deleteList(list){
        console.log(list)
        let deleteDoc = db.collection('samplePackages').doc(list).delete();
        if(list === this.selectedSamplePackage) this.selectedSamplePackage = ''
      },
      removeProductSelectionForList () {
        this.selectedProductForList = ''
        this.addExistingProductErrors.product = ''
      },
      removeContactSelectionForList () {
        this.selectedProductVariationForList = ''
        this.addExistingProductErrors.productVariation = ''
      },
      updateSamplePackageName(name){
        if(this.selectedSamplePackage !== undefined && this.selectedSamplePackage !== ''){
        db.collection('samplePackages').doc(this.selectedSamplePackage).set({
            updated_at:firebase.firestore.FieldValue.serverTimestamp(),
            updated_by:this.user.uid,
            name
          }, { merge: true })
        }
      },
      async selectFileForMediaViewer(fileId){
        var selectedFileForMediaViewer = ""
        var docRef = db.collection("files").doc(fileId);
        var doc = await docRef.get()
        this.selectedFileForMediaViewer = doc.data()
      },
      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      wait(ms){
          var start = new Date().getTime();
          var end = start;
          while(end < start + ms) {
            end = new Date().getTime();
        }
      },
      // AUTOMATE NEXT CODE
      transferProductCodes(){
        
        Object.keys(this.productsData).forEach(id => {
          var p = this.productsData[id]
          var avecorSku = this.productsData[id].productVariationSkus.split(',')[0]
          let pattern = /^[0-9]{5}(-)/;
          let pattern2 = /^[0-9]{5}$/;
          if((pattern.test(avecorSku) || pattern2.test(avecorSku)) && !p.archived && !p.avecorSku){
            avecorSku = avecorSku.split('-')[0]
            //console.log(avecorSku,id)
            this.$store.dispatch('product/set', {
              id, avecorSku
            })

          }
        })
      },
      addProductCodes(){
        var highestProductNumber = 0
        var numberOfMissing = 0
        var ids = []
        Object.keys(this.products).forEach(key => {
          var p = this.products[key]
          if(p.avecorSku && !isNaN(Number(p.avecorSku))){
            var num = Number(p.avecorSku)
            if (num > highestProductNumber) highestProductNumber = num
          }
          else if(p.avecorSku){

          }
          else {
            if(!p.archived){
              numberOfMissing += 1
              ids.push(p.id)
            }
            
            //console.log(p.id)
          }
        })
        for(var i = 0; i < 100; i++){
          if(ids[i]){
            var id = ids[i]
            highestProductNumber = highestProductNumber + 1
            var avecorSku = highestProductNumber
            this.$store.dispatch('product/set', {
              id, 
              avecorSku
            })
            console.log({id,avecorSku})
          }
          
        }
        /* console.log(highestProductNumber)
        console.log(numberOfMissing)
        console.log(ids) */
      },
      updateColorCodes(){
        var t = this
        var mod = 0
        Object.keys(this.productVariations).forEach(async function(key, index) {
          var pv = t.productVariations[key]
          if(pv.colorCode && pv.colorCode === '217'){
            console.log(t.products[pv.productId].name.fi + '  ' + t.products[pv.productId].avecorSku + '-' + pv.colorCode)
            /* t.$store.dispatch('productVariation/set', {
              id:key, 
              colorCode:'020'
            }) */
          }
        })
      },
      updateSizes(){
        var t = this
        var mod = 0
        Object.keys(this.productVariations).forEach(async function(key, index) {
          var pv = t.productVariations[key]
          if(pv.size && !t.settings.sizes.includes(pv.size)){
            console.log(pv.size)
          }
        })
      },
      generateProductsData(){
        var productsData = {}
        var t = this
        if (!this.loaded) return productsData
        Object.keys(this.productVariations).map(async function(key, index) {
          var pv = t.productVariations[key]
          // USED TO REMOVE VARIATION WITHOUT A PRODUCT ID
          /* if(pv.productId === undefined ) { 
            //console.log(pv)
            await t.$store.dispatch('productVariation/delete', key)  
            t.wait(20)
          } */
          if(typeof t.products[pv.productId] === "undefined" || t.products[pv.productId] === "") {console.log (); return}
          typeof productsData[pv.productId] === "undefined" ? productsData[pv.productId] = {} : ""
          Object.defineProperty(productsData, pv.productId, { configurable: false });
          typeof productsData[pv.productId].productVariations === "undefined" ? productsData[pv.productId].productVariations = {} : ""
          productsData[pv.productId].id = pv.productId
          productsData[pv.productId].created_at = t.products[pv.productId].created_at
          productsData[pv.productId].updated_at = t.products[pv.productId].updated_at ? t.products[pv.productId].updated_at : ''
          t.products[pv.productId].archived !== undefined ? productsData[pv.productId].archived = t.products[pv.productId].archived : productsData[pv.productId].archived = false
          t.products[pv.productId].listed !== undefined ? productsData[pv.productId].listed = t.products[pv.productId].listed : productsData[pv.productId].listed = false
          t.products[pv.productId].warehoused ? productsData[pv.productId].warehoused = t.products[pv.productId].warehoused : productsData[pv.productId].warehoused = false
          productsData[pv.productId].avecorSku = t.products[pv.productId].avecorSku ? t.products[pv.productId].avecorSku : ''
          productsData[pv.productId].wholesaleSku = t.products[pv.productId].wholesaleSku ? t.products[pv.productId].wholesaleSku : ''
          productsData[pv.productId].deliveryTime = t.products[pv.productId].deliveryTime
          productsData[pv.productId].isPrintProduct = t.products[pv.productId].isPrintProduct
          productsData[pv.productId].isDoubleSidePrintPossible = t.products[pv.productId].isDoubleSidePrintPossible
          productsData[pv.productId].vatPercentage = t.products[pv.productId].vatPercentage
          productsData[pv.productId].name = t.products[pv.productId].name.fi
          productsData[pv.productId].nameWholesale = t.products[pv.productId].name.wholesale ? t.products[pv.productId].name.wholesale : ''
          productsData[pv.productId].nameEnglish = t.products[pv.productId].name.en ? t.products[pv.productId].name.en : ''
          productsData[pv.productId].officeComments = t.products[pv.productId].officeComments
          productsData[pv.productId].printFormats = ""
          productsData[pv.productId].selectedProductImageId = t.products[pv.productId].selectedProductImageId !== undefined ? t.products[pv.productId].selectedProductImageId : ""
          productsData[pv.productId].productTags = ""
          //productsData[pv.productId].printFormats = t.products[pv.productId].printFormats && Array.isArray(t.products[pv.productId].printFormats) ? t.products[pv.productId].printFormats.join(', ') : ''
          t.products[pv.productId].printFormats !== undefined ? t.products[pv.productId].printFormats.forEach((format,i) => {
            if(i === 0) t.printFormatsObject[format] !== undefined ? productsData[pv.productId].printFormats += t.printFormatsObject[format].fi : ""
            else t.printFormatsObject[format] !== undefined ? productsData[pv.productId].printFormats += ', '+t.printFormatsObject[format].fi : ""
          }) : ""
          
          productsData[pv.productId].wholesaleCompany = typeof t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany] !== "undefined" ? t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].name : ""
          productsData[pv.productId].printShops = ""
          t.products[pv.productId].printShops !== undefined && Array.isArray(t.products[pv.productId].printShops) ? t.products[pv.productId].printShops.forEach(shop => {
            t.printShops[shop] !== undefined ? productsData[pv.productId].printShops += t.printShops[shop].name +", " : ""
            //console.log(productsData[pv.productId].printShops)
          }) : ""
          //productsData[pv.productId].printShops = typeof t.printShops[t.products[pv.productId].wholesaleCompany] !== "undefined" ? t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].name : ""
          /* productsData[pv.productId].productVariationSkus === undefined ? productsData[pv.productId].productVariationSkus = '' : ''
          if(productsData[pv.productId].productVariationSkus === '') productsData[pv.productId].productVariationSkus += pv.sku 
          else !productsData[pv.productId].productVariationSkus.includes(pv.sku) ? productsData[pv.productId].productVariationSkus += ', '+pv.sku : '' */
          
          productsData[pv.productId].productVariationWholesaleSkus === undefined ? productsData[pv.productId].productVariationWholesaleSkus = '' : ''
          if(productsData[pv.productId].productVariationWholesaleSkus === '') productsData[pv.productId].productVariationWholesaleSkus += pv.wholesaleSku ? pv.wholesaleSku : ''
          else pv.wholesaleSku && !productsData[pv.productId].productVariationWholesaleSkus.includes(pv.wholesaleSku) ? productsData[pv.productId].productVariationWholesaleSkus += ', '+ pv.wholesaleSku : ''
          
          
          productsData[pv.productId].productVariations[pv.id] = {id: pv.id, size:pv.size, colorCode:pv.colorCode,warehoused: pv.warehoused !== undefined ? pv.warehoused : false}
          return 
        })
        Object.keys(this.products).map(function(key, index) {
          var p = t.products[key]
          if(productsData[p.id] === undefined) {
            productsData[p.id] = {}
            productsData[p.id].id = p.id
            if(!t.products[p.id].name) console.log(t.products[p.id])
            productsData[p.id].name = t.products[p.id].name.fi
            productsData[p.id].officeComments = t.products[p.id].officeComments
            productsData[p.id].productVariations = {}
            productsData[p.id].created_at = t.products[p.id].created_at
            productsData[p.id].archived = t.products[p.id].archived
            productsData[p.id].listed = t.products[p.id].listed
            productsData[p.id].avecorSku = t.products[p.id].avecorSku ? t.products[p.id].avecorSku : ''
            productsData[p.id].wholesaleSku = t.products[p.id].wholesaleSku ? t.products[p.id].wholesaleSku : ''
            productsData[p.id].deliveryTime = t.products[p.id].deliveryTime
            productsData[p.id].isPrintProduct = t.products[p.id].isPrintProduct
            productsData[p.id].isDoubleSidePrintPossible = t.products[p.id].isDoubleSidePrintPossible
            productsData[p.id].printFormats = ""
            productsData[p.id].selectedProductImageId = t.products[p.id].selectedProductImageId !== undefined ? t.products[p.id].selectedProductImageId : ""
            productsData[p.id].productTags = ""
            t.products[p.id].printFormats !== undefined ? t.products[p.id].printFormats.forEach((format,i) => {
              if(i === 0) t.printFormatsObject[format] !== undefined ? productsData[p.id].printFormats += t.printFormatsObject[format].fi : ""
              else t.printFormatsObject[format] !== undefined ? productsData[p.id].printFormats += ', '+t.printFormatsObject[format].fi : ""
            }) : ""
            
            /* t.products[p.id].printFormats !== undefined ? t.products[p.id].printFormats.forEach(format => {
              //console.log(t.printFormatsObject[format])
              t.printFormatsObject[format] !== undefined ? productsData[p.id].printFormats += t.printFormatsObject[format].fi : ""
            }) : "" */
            
            productsData[p.id].wholesaleCompany = typeof t.wholesaleCompanies[t.products[p.id].wholesaleCompany] !== "undefined" ? t.wholesaleCompanies[t.products[p.id].wholesaleCompany].name : ""
            /* t.products[p.id].printShops !== undefined ? t.products[p.id].printShops.forEach(shop => {
              t.printShops[shop] !== undefined ? productsData[p.id].printShops += t.printShops[shop].name +", " : ""
            }) : "" */
            //productsData[p.id].productVariationSkus === undefined ? productsData[p.id].productVariationSkus = '' : ''
            
            
          }
        })
        Object.keys(this.orderedProducts).map(function(key, index) {
          var op = t.orderedProducts[key]
          var pv = null
          var productId = null
          
          typeof op.productVariationId !== "undefined" ? pv = t.productVariations[op.productVariationId] : ""
          pv ? productId = pv.productId : ""
          
          if(productId != null && typeof productsData[productId] !== "undefined" && typeof productsData[productId].orderedProducts === "undefined") {
            productsData[productId].orderedProducts = {}
          } 
          //console.log(productsData[productId])
          productId && productsData[productId] !== "undefined" ? productsData[productId].orderedProducts[key] = {id:key} : ""
        })
        //console.log(productsData)
        this.productsData = productsData
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      updateProduct(id,field,value) {
        if(field === 'avecorSku' || field === 'wholesaleSku'){
          if (confirm('Haluatko varmasti muuttaa tuotekoodia?')) {

            if(id && field && value !== undefined && value !== null) this.$store.dispatch('product/set', {
              id, [field]:value
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
          else {
            var clone = JSON.parse(JSON.stringify(this.keysObj))
            if(this.keysObj[id]) clone[id] += 1 
            else clone[id] = 1
            this.keysObj = clone
          }
        }
        else {
          if(id && field && value !== undefined && value !== null) this.$store.dispatch('product/set', {
            id, [field]:value
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      toggleArchive(item) {
        var archived = item.archived ? true : false
        var m = ''
        if(archived) {m = 'Haluatko varmasti poistaa arkistointi tilan?'}
        else {m = 'Haluatko varmasti arkistoida tämän tuotetteen?'}
        console.log(item)
        if (confirm(m)) {
          if(archived && (item.avecorSku === undefined || item.avecorSku.length == 0)){
            var h = this.highestProductNumber
            console.log(h)
            this.$store.dispatch('product/set', {id:item.id, archived:!item.archived, avecorSku:h})
          }
          else {
            this.$store.dispatch('product/set', {id:item.id, archived:!item.archived})
          }
          var productVariations = this.productsData[item.id].productVariations
          Object.keys(productVariations).forEach(variationId =>{
            this.$store.dispatch('productVariation/set', {id:variationId, archived:!item.archived})
          })
        }
      },
      async toggleListed(item) {
        var listed = item.listed ? true : false
        var newListedValue = !listed
        var m = ''
        if(listed) {m = 'Haluatko varmasti poistaa tuotteen hinnastosta tilan?'}
        else {m = 'Haluatko varmasti lisätä hinnastoon tämän tuotetteen?'}
        if (confirm(m)) {
          this.$store.dispatch('product/set', {id:item.id, listed:newListedValue})

          var t= this
          if(!newListedValue){
            if(this.allAccess){
              var docRef = db.collection("config").doc("pricingLayout")
              var doc = await docRef.get()
              var pricingLayout = doc.data()
              
                  
              var copy = JSON.parse(JSON.stringify(pricingLayout))
              var secondCopy = JSON.parse(JSON.stringify(pricingLayout))
              var updatesNeeded = false
              Object.keys(copy.sections).forEach(sId => {
                if(copy.sections[sId].subSections){
                  Object.keys(copy.sections[sId].subSections).forEach(ssId => {
                    if(copy.sections[sId].subSections[ssId].products){
                      Object.keys(copy.sections[sId].subSections[ssId].products).forEach(pId => {
                        if(pId === item.id){
                          console.log(`Id found under section ${copy.sections[sId].name}, subsection ${copy.sections[sId].subSections[ssId].name}, product id ${pId}`)
                          delete secondCopy.sections[sId].subSections[ssId].products[pId]
                          updatesNeeded = true
                        }
                      })
                    }
                  })
                }
              })
              if(updatesNeeded){
                //console.log(copy)
                //console.log(secondCopy)
                db.collection('config').doc("pricingLayout").update(secondCopy)
              }
              
            }
          }

        }
      },
      toggleWarehouse(item) {
        this.$store.dispatch('product/set', {id:item.id, warehoused:!item.warehoused})
        console.log(this.productsData[item.id].productVariations)
        var productVariations = this.productsData[item.id].productVariations
        Object.keys(productVariations).forEach(variationId =>{
          this.$store.dispatch('productVariation/set', {id:variationId, warehoused:!item.warehoused})
        })
        /* Object.keys(productVariations).forEach(variationId =>{
          this.$store.dispatch('productVariation/set', {id:variationId, warehoused:!productVariations[variationId].warehoused})
        }) */
      },
      deleteProduct(productId){
        var t = this
        if (confirm('Haluatko varmasti poistaa?')) {
          Object.keys(this.productsData[productId].productVariations).map(function(key,index){
            t.$store.dispatch('productVariation/delete', key)  
          })
          this.$store.dispatch('product/delete', productId)
          this.selectedProductId = ""
        }
      },
      async addProduct() {
        this.newProductModalVisible = true
        /* let {...y} = this.newItem;
        const newProductId = await this.$store.dispatch('product/set', y) */
        //console.log(newProductId)
        //this.addProductVariation(newProductId)
      },
      async addProductVariation(productId) {
        //console.log(productId)
        let {...y} = this.newProductVariation;
        const newId = await this.$store.dispatch('productVariation/set', {...y, productId})
      },
    }
  }
</script>

<style>
.button-pointer {
  cursor:pointer !important;
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/ProductsTable.vue